/* CELLIN storefront helpers. */

// Clicking the dimmed page behind the cart drawer closes it (the drawer overlays the page, rhode-style).
document.addEventListener('click', (event) => {
  const drawer = document.querySelector('theme-drawer#cart-drawer[open]');
  if (!drawer || !event.target.closest?.('.page-wrapper') || event.target.closest('theme-drawer, dialog')) return;
  event.preventDefault();
  event.stopPropagation();
  drawer.close?.();
}, true);
